if (!customElements.get('sc-announcement-banner')) {
  class ScAnnouncementBanner extends HTMLElement {
    connectedCallback() {
      if (this.scInitialized) return;
      this.scInitialized = true;

      this.mode = this.dataset.mode || 'marquee';
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.speed = Math.max(Number(this.dataset.speed) || 5, 2) * 1000;
      this.slides = Array.from(this.querySelectorAll('[data-sc-announcement-slide]'));
      this.prevButton = this.querySelector('[data-sc-announcement-prev]');
      this.nextButton = this.querySelector('[data-sc-announcement-next]');
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.currentIndex < 0) this.currentIndex = 0;

      if (this.mode === 'marquee') {
        this.setupMarqueePause();
        return;
      }

      this.bindSliderControls();
      this.startAutoRotate();

      if (this.reducedMotion.addEventListener) {
        this.reducedMotion.addEventListener('change', () => {
          this.stopAutoRotate();
          this.startAutoRotate();
        });
      }
    }

    disconnectedCallback() {
      this.stopAutoRotate();
      this.scInitialized = false;
    }

    setupMarqueePause() {
      const pause = () => this.classList.add('sc-announcement-banner--paused');
      const resume = () => this.classList.remove('sc-announcement-banner--paused');

      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);
      this.addEventListener('mouseenter', pause);
      this.addEventListener('mouseleave', resume);
    }

    bindSliderControls() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.showSlide(this.currentIndex - 1);
          this.restartAutoRotate();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.showSlide(this.currentIndex + 1);
          this.restartAutoRotate();
        });
      }
    }

    showSlide(index) {
      if (!this.slides.length) return;

      const nextIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      this.currentIndex = nextIndex;
    }

    startAutoRotate() {
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.speed = Math.max(Number(this.dataset.speed) || 5, 2) * 1000;

      if (!this.autoRotate || this.slides.length < 2) return;
      if (this.reducedMotion && this.reducedMotion.matches) return;

      this.stopAutoRotate();
      this.timer = window.setInterval(() => {
        this.showSlide(this.currentIndex + 1);
      }, this.speed);
    }

    stopAutoRotate() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoRotate() {
      this.stopAutoRotate();
      this.startAutoRotate();
    }
  }

  customElements.define('sc-announcement-banner', ScAnnouncementBanner);
}

document.addEventListener('shopify:section:load', (event) => {
  const banner = event.target.querySelector('sc-announcement-banner');
  if (!banner) return;
  if (typeof banner.disconnectedCallback === 'function') banner.disconnectedCallback();
  if (typeof banner.connectedCallback === 'function') banner.connectedCallback();
});
